define([
	"dojo/_base/declare",
	"csi/_base/storage",
	"csi/locale",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/state/rootStore",
	"csi/xml",
	"csi/xml/Query"
], function(declare,storage,locale,ToolbarPluginSwitchboard,{ routerStore },xml,Query) {

	var	STORAGE_KEY = "MerchPlanSeason",
	_storeSeasons,
	_urlPlan,
	_urlSeason;
	
	return declare(ToolbarPluginSwitchboard, {
		switchboardPath: "Child:Versions/Child:Season",
		
		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: find the MerchVersion associated to the chose season
			view.set("urlSeason", node ? node.$URL : null);
			_urlSeason = view.get("urlSeason");
			storage.set(STORAGE_KEY, _urlSeason);
		},

		onRefresh: function() {
			// summary: reset seasons store when refreshing view
			_storeSeasons = null;
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: only available if table has relationship
			return !ctx.bPrint;
		},
		
		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: if switching to new plan, then reset seasons store
			const urlPlan = routerStore.getBreadcrumbNodeURL("MerchPlan");
			if (urlPlan != _urlPlan) {
				_urlSeason = _urlPlan ? null : storage.get(STORAGE_KEY);
				_storeSeasons = null;
				_urlPlan = urlPlan;
			}
			
			return this.inherited(arguments, [_urlPlan, r]);
		},
		
		_onDefaultValue: function(/*String?*/preferredValue, /*String?*/defaultValue) {
			// summary: use previously selected season as default value if no value specified
			if (this.store && this.store.get(_urlSeason)) {
				defaultValue = _urlSeason;
			}
			
			this.inherited(arguments, [preferredValue, defaultValue]);
		},
		
		_setStoreAttr: function(/*Store?*/store) {
			// summary: always use season store, and track it when created
			this.inherited(arguments, [_storeSeasons]);
			_storeSeasons = this.store;
		},

		postCreate: function() {
			this.defAction.m_fixedQuery = new Query().Attr("Active", xml.OP_EQUALS, true);

			this.inherited(arguments);
		}
	});
});